module.exports = __webpack_public_path__ + "static/media/bea.3f88969a.jpg";